(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-compare"] && !Shopify.designMode) return;
  try {
    
  function getValueByKey(response, key) {
    const foundMetafield = response.metafields.find((metafield) => metafield.key === key);
    //console.log(key, foundMetafield.value);
    return foundMetafield ? foundMetafield.value : '-';
  }

  var pre_val_s1, pre_val_s2, pre_val_s3;
  var cur_val_s1, cur_val_s2, cur_val_s3;
  $('.select-1').change(function () {
    cur_val_s1 = $(this).val();
    if (cur_val_s1 != pre_val_s1) {
      console.log(pre_val_s1 + 'old & current' + cur_val_s1);
      if (pre_val_s1) {
        $('.select-1,.select-2,.select-3')
          .find('option[value="' + pre_val_s1 + '"]')
          .prop('disabled', false);
      }
      pre_val_s1 = cur_val_s1;
      console.log(pre_val_s1 + 'old & current' + cur_val_s1);
    }
  });

  $('.select-2').change(function () {
    cur_val_s2 = $(this).val();
    if (cur_val_s2 != pre_val_s2) {
      //console.log(pre_val_s2+"old & current"+cur_val_s2);
      if (pre_val_s2) {
        $('.select-1,.select-2,.select-3')
          .find('option[value="' + pre_val_s2 + '"]')
          .prop('disabled', false);
      }
      pre_val_s2 = cur_val_s2;
      //console.log(pre_val_s2+"old & current"+cur_val_s2);
    }
  });

  $('.select-3').change(function () {
    cur_val_s3 = $(this).val();
    if (cur_val_s3 != pre_val_s3) {
      //console.log(pre_val_s3+"old & current"+cur_val_s3);
      if (pre_val_s3) {
        $('.select-1,.select-2,.select-3')
          .find('option[value="' + pre_val_s3 + '"]')
          .prop('disabled', false);
      }
      pre_val_s3 = cur_val_s3;
      //console.log(pre_val_s3+"old & current"+cur_val_s3);
    }
  });

  $('select').on('change', function () {
    var value = $(this).val();
    var col = $(this).attr('rel-col');
    var handle = $(this).find('option:selected').val();

    $('select')
      .not(this)
      .find('option[value="' + value + '"]')
      .prop('disabled', true);

    if (value == 'Select Product') {
      $(
        `.${col}.image-div, .${col}.name, .${col}.for_room, .${col}.engg_plastic, .${col}.wattage, .${col}.water_capacity, .${col}.pop_up_panel, .${col}.side_pads, .${col}.remote_control, .${col}.auto_louver_movement, .${col}.cool_flow_dispenser, .${col}.empty_tank_alarm, .${col}.free_trolley, .${col}.cooling_media, .${col}.product_dimensions, .${col}.price, .${col}.discount, .${col}.addtocart-btn`
      ).html('');

      return;
    } else {
      $(`.${col}`).addClass('loading');

      // Replace with your actual Shopify store domain and access token
      const storeDomain = 'shop.symphonylimited.com';
      const storefrontAccessToken = 'eb31dc9344726e8283cc2da6db901102';

      // Function to fetch the store name from the Storefront API
      async function getProductData() {
        try {
          const response = await fetch(`https://${storeDomain}/api/2023-01/graphql.json`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
            },
            body: JSON.stringify({
              query: `
          {
            product(handle: "${handle}") {
              title
              featuredImage {
                url
              }
              metafields(identifiers: [
                {namespace: "compare", key: "for_room"},
                {namespace: "compare", key: "engg_plastic"},
                {namespace: "compare", key: "wattage"},
                {namespace: "compare", key: "water_capacity"},
                {namespace: "compare", key: "pop_up_panel"},
                {namespace: "compare", key: "side_pads"},
                {namespace: "compare", key: "remote_control"},
                {namespace: "compare", key: "auto_louver_movement"},
                {namespace: "compare", key: "cool_flow_dispenser"},
                {namespace: "compare", key: "empty_tank_alarm"},
                {namespace: "compare", key: "free_trolley"},
                {namespace: "compare", key: "cooling_media"},
                {namespace: "compare", key: "product_dimensions"}
              ]) {
                id
                key
                value
              }
              variants(first: 1) {
                nodes {
                  compareAtPrice {
                    amount
                  }
                  price {
                    amount
                  }
                  id
                  currentlyNotInStock
                }
              }
            }
          }
          `,
            }),
          });

          const responseData = await response.json();

          // Do something with the store name
          //console.log('Data Name:', responseData);
          var product = responseData.data.product;
          var metafields = product.metafields;
          var variants = product.variants.nodes[0];

          $(`.${col}.name`).text(product.title);

          for (var i = 0; i < metafields.length; i++) {
            var current_metafield = metafields[i];
            if (current_metafield != null) {
              var key_value = getValueByKey(product, current_metafield.key);
              if (key_value == 'true' || key_value == 'false') {
                $(`.${col}.${current_metafield.key}`).html(
                  key_value == 'true'
                    ? '<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60"><g id="noun-check-4389206" transform="translate(-2 -2)"><path id="Path_347228" data-name="Path 347228" d="M32,2A30,30,0,1,0,62,32,30,30,0,0,0,32,2ZM46.13,26.48,30.86,41.75a3,3,0,0,1-4.26,0l-8.73-8.73a3,3,0,1,1,4.26-4.23l6.6,6.6L41.87,22.25a3,3,0,0,1,4.26,4.23Z" transform="translate(0 0)" fill="#6bb52b"/></g></svg>'
                    : '<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60"><g id="noun-close-3398364" transform="translate(-2 -2)"><path id="Path_347227" data-name="Path 347227" d="M36.242,32l8.487-8.484a3,3,0,0,0-4.245-4.245h0L32,27.758l-8.484-8.487a3,3,0,0,0-4.245,4.245h0L27.758,32l-8.487,8.484a3,3,0,1,0,4.245,4.245L32,36.242l8.484,8.487a3,3,0,0,0,4.245-4.245ZM32,62A30,30,0,1,1,62,32,30,30,0,0,1,32,62Z" transform="translate(0 0)" fill="#e66839"/></g></svg>'
                );
              } else {
                $(`.${col}.${current_metafield.key}`).text(key_value);
              }
            } else {
              //console.log('Key is null');
            }
          }

          $(`.${col}.price`).text(`₹ ${parseInt(variants.price.amount)}`);
          $(`.${col}.discount`).text(
            variants.compareAtPrice.amount > 0
              ? `upto ${Math.floor(
                  ((variants.compareAtPrice.amount - variants.price.amount) / variants.compareAtPrice.amount) * 100
                )}%`
              : 'No Discount'
          );
          $(`.${col}.image-div`).html(
            `<a href="${product.featuredImage.url}" target="_blank">
            <img
              loading="lazy"
              src="${product.featuredImage.url}"
              height="300"
              width="300"
              alt="${product.title}"
            >
          </a>`
          );
          var graphql_id = variants.id;
          var variants_id = graphql_id.split('/')[4];
          $(`.${col}.addtocart-btn`).html(
            `<a
            href="javascript:;"
            class="cart_btn"
            variant-id="${variants_id}"
            data-ava="${variants.currentlyNotInStock}"
            >Add To Cart</a>`
          );

          $(`.${col}`).removeClass('loading');
        } catch (error) {
          console.error('Error fetching store name:', error);
        }
      }

      // Call the function to get the store name
      getProductData();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // ── Shared API queue ─────────────────────────────────────────────────────
    if (typeof window.ytNewQueue === 'undefined') {
      window.ytNewQueue = [];
    }

    // ── Load YouTube IFrame API script once ──────────────────────────────────
    function loadYTApi() {
      if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
      }
    }

    // ── Chain onYouTubeIframeAPIReady so other sections are not clobbered ────
    var prevReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prevReady === 'function') prevReady();
      window.ytNewQueue.forEach(function (item) { createPlayer(item); });
      window.ytNewQueue = [];
    };

    // ── Create a YT.Player inside the placeholder div ────────────────────────
    function createPlayer(item) {
      new YT.Player(item.el, {
        videoId: item.videoId,
        playerVars: { autoplay: 1, playsinline: 1, rel: 0, modestbranding: 1 },
        events: {
          onReady: function (e) { e.target.playVideo(); }
        }
      });
    }

    // ── Attach click listener to every player card ───────────────────────────
    function initSection() {
      document.querySelectorAll('.yt-new-section__player').forEach(function (player) {
        if (player.dataset.ytInit) return;
        player.dataset.ytInit = '1';

        var btn        = player.querySelector('.yt-new-section__play-btn');
        var thumbWrap  = player.querySelector('.yt-new-section__thumb-wrap');
        var iframeWrap = player.querySelector('.yt-new-section__iframe-wrap');

        // No thumbnail — direct embed already in DOM, nothing to do
        if (!btn || !iframeWrap) return;

        btn.addEventListener('click', function () {
          var videoType = player.dataset.videoType;
          var videoId   = player.dataset.video;
          var videoSrc  = player.dataset.videoSrc;

          if (videoType === 'file' ? !videoSrc : !videoId) return;

          // Keep thumbnail visible so card size is fixed; overlay video on top
          btn.style.display = 'none';

          // Show iframe container as overlay
          iframeWrap.style.display = 'block';

          // Direct Shopify/other hosted video file — play with a native <video> element
          if (videoType === 'file') {
            var video = document.createElement('video');
            video.src = videoSrc;
            video.controls = true;
            video.autoplay = true;
            video.playsInline = true;
            video.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;';
            iframeWrap.appendChild(video);
            video.play().catch(function () {});
            return;
          }

          // YouTube video — create placeholder div for YT Player
          var pid = 'yt-pid-' + Date.now();
          var div = document.createElement('div');
          div.id  = pid;
          iframeWrap.appendChild(div);

          if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
            createPlayer({ el: pid, videoId: videoId });
          } else {
            window.ytNewQueue.push({ el: pid, videoId: videoId });
            loadYTApi();
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSection);
    } else {
      initSection();
    }

    document.addEventListener('shopify:section:load', initSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // Initialize YouTube queue if it doesn't exist
    if (typeof window.youtubeQueue === 'undefined') {
      window.youtubeQueue = [];
    }

    // Load YouTube API if not already loaded
    function loadYouTubeAPI() {
      if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
    }

    // Process YouTube queue when API is ready
    function onYouTubeIframeAPIReady() {
      if (window.youtubeQueue && window.youtubeQueue.length > 0) {
        window.youtubeQueue.forEach(function (item) {
          if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
            new YT.Player(item.id, {
              height: item.height,
              width: item.width,
              videoId: item.videoId,
              playerVars: {
                autoplay: 1,
                playsinline: 1,
                rel: 0,
                origin: window.location.origin,
              },
              events: {
                onReady: function (event) {
                  event.target.playVideo();
                },
              },
            });
          }
        });
        window.youtubeQueue = [];
      }
    }

    // Make onYouTubeIframeAPIReady globally available
    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

    // Initialize when DOM is ready
    function initYouTubeVideo() {
      var videoElements = document.querySelectorAll('.video-img-container, .youtube-icon, .youtube-sec');

      videoElements.forEach(function (element) {
        // Skip if already has event listener
        if (element.dataset.listenerAdded) {
          return;
        }
        element.dataset.listenerAdded = 'true';

        element.addEventListener('click', function (e) {
          var wrapper = element.closest('.youtube-sec');
          if (!wrapper) return;

          // Prevent re-trigger
          if (wrapper.classList.contains('played')) return;

          var videoId = wrapper.dataset.video;
          if (!videoId) return;

          var isVimeo = wrapper.hasAttribute('data-vimeo');
          var vimeoHash = wrapper.dataset.vimeoHash || '';

          var iframeContainer = wrapper.querySelector('.iframe-dv');
          var thumbnailImg = wrapper.querySelector('.youtubeThumbnail');
          var playIcon = wrapper.querySelector('.youtube-icon');

          if (!iframeContainer) return;

          var width = thumbnailImg ? thumbnailImg.offsetWidth : 1366;
          var height = thumbnailImg ? thumbnailImg.offsetHeight : 392;

          // Mark as played
          wrapper.classList.add('played');

          if (thumbnailImg) thumbnailImg.style.display = 'none';
          if (playIcon) playIcon.style.display = 'none';
          iframeContainer.innerHTML = '';

          if (isVimeo) {
            var vimeoSrc = 'https://player.vimeo.com/video/' + videoId;
            if (vimeoHash) {
              vimeoSrc += '?h=' + vimeoHash + '&autoplay=1';
            } else {
              vimeoSrc += '?autoplay=1';
            }

            var iframe =
              '<iframe src="' +
              vimeoSrc +
              '" width="' +
              width +
              '" height="' +
              height +
              '" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
            iframeContainer.innerHTML = iframe;
          } else {
            var containerId = 'youtube-player-' + Date.now();
            iframeContainer.innerHTML = '<div id="' + containerId + '"></div>';

            // Load YouTube API
            loadYouTubeAPI();

            if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
              new YT.Player(containerId, {
                height: height,
                width: width,
                videoId: videoId,
                playerVars: {
                  autoplay: 1,
                  playsinline: 1,
                  rel: 0,
                  origin: window.location.origin,
                },
                events: {
                  onReady: function (event) {
                    event.target.playVideo();
                  },
                },
              });
            } else {
              window.youtubeQueue.push({
                id: containerId,
                videoId: videoId,
                width: width,
                height: height,
              });
            }
          }
        });
      });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initYouTubeVideo();
      });
    } else {
      initYouTubeVideo();
    }

    // Re-initialize for dynamically loaded content
    if (typeof document.addEventListener !== 'undefined') {
      document.addEventListener('shopify:section:load', function () {
        initYouTubeVideo();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
